import { CSSProperties } from 'react';

import { IconProps } from './Close';

export interface WeatherSunProps extends IconProps {
  style?: CSSProperties;
}

const Icon = ({ width, height, size, style }: WeatherSunProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || size || '22'}
      height={height || size || '22'}
      viewBox="0 0 22 22"
      style={style}
    >
      \
      <g fill="none" fillRule="evenodd" stroke="#FEBD01">
        \
        <path
          strokeWidth="1.2"
          d="M10.765 6.105c-2.666 0-4.839 2.196-4.839 4.896 0 2.7 2.173 4.896 4.839 4.896 2.666 0 4.839-2.195 4.839-4.896 0-2.7-2.173-4.896-4.84-4.896z"
        />
        \
        <path
          strokeLinecap="round"
          strokeWidth=".7"
          d="M10.517.885c0-.124.105-.225.225-.225.124 0 .225.096.225.225v2.423a.227.227 0 0 1-.225.226.222.222 0 0 1-.225-.226V.885zM16.48 2.69a.227.227 0 0 1 .314-.05c.1.072.126.209.05.314l-1.424 1.96a.227.227 0 0 1-.315.05.222.222 0 0 1-.049-.314l1.424-1.96zm3.77 4.984a.227.227 0 0 1 .285.144.222.222 0 0 1-.145.284l-2.304.748a.227.227 0 0 1-.284-.144.222.222 0 0 1 .145-.283l2.304-.749zm.14 6.263a.227.227 0 0 1 .145.283.222.222 0 0 1-.284.144l-2.304-.749a.227.227 0 0 1-.145-.283.222.222 0 0 1 .284-.144l2.304.749zm-3.546 5.148c.073.1.048.243-.05.314a.222.222 0 0 1-.314-.05l-1.424-1.96a.227.227 0 0 1 .05-.315.222.222 0 0 1 .314.05l1.424 1.96zm-5.877 2.067a.227.227 0 0 1-.225.226.222.222 0 0 1-.225-.226v-2.423c0-.124.105-.225.225-.225.124 0 .225.095.225.225v2.423zm-5.963-1.803a.227.227 0 0 1-.314.05.222.222 0 0 1-.05-.314l1.425-1.96a.227.227 0 0 1 .314-.05c.1.072.126.209.05.314l-1.425 1.96zm-3.77-4.985a.227.227 0 0 1-.284-.144.222.222 0 0 1 .145-.283l2.304-.749a.227.227 0 0 1 .284.144.222.222 0 0 1-.145.283l-2.305.75zm-.14-6.262a.227.227 0 0 1-.144-.284.222.222 0 0 1 .283-.144l2.305.749a.227.227 0 0 1 .145.283.222.222 0 0 1-.284.144l-2.304-.748zm3.547-5.148a.227.227 0 0 1 .049-.315.222.222 0 0 1 .314.05l1.424 1.96c.074.101.049.244-.049.315a.222.222 0 0 1-.314-.05L4.64 2.953z"
        />
        \
      </g>
      \
    </svg>
  );
};

export default Icon;
